import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { map } from 'rxjs/operators';

@Injectable()
export class LanguageService {
  public languages: string[] = ['de', 'en', 'fr', 'pl', 'ru', 'es', 'cz', 'tr'];
  constructor(private cookies: CookieService, private translate: TranslateService) {}

  public getDefaultLanguage(): string {
    let language: string;
    const cookieLanguage = this.cookies.get('lang');
    const browserLanguage = this.translate.getBrowserLang();
    if (this.isLanguage(cookieLanguage)) {
      this.setLanguage(cookieLanguage);
      language = cookieLanguage;
    } else if (this.isLanguage(browserLanguage)) {
      this.setLanguage(browserLanguage);
      language = browserLanguage;
    } else {
      this.setLanguage('en');
      language = 'en';
    }
    return language;
  }

  public setLanguage(language: string) {
    return this.translate.use(language).pipe(
      map(() => {
        this.cookies.delete('lang', '/');
        this.cookies.set('lang', language, 360000, '/');
        return true;
      }),
    );
  }

  public isLanguage(language: string): boolean {
    return this.languages.indexOf(language) !== -1;
  }
}
